import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=3e673f8c&scoped=true&"
import script from "./consumables.vue?vue&type=script&lang=js&"
export * from "./consumables.vue?vue&type=script&lang=js&"
import style0 from "./consumables.vue?vue&type=style&index=0&id=3e673f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e673f8c",
  null
  
)

export default component.exports